export { default } from "./PageSkeleton";
